/* eslint-disable */
import { getHtmlStyle } from '../transfer';
import { customEventFunAttr, customEventTypeAttr } from '../event';

// bugfix，广交会结构化消息中引用超级大图，导致工作台crash，需要在src中加width和height参数取小图，所以这里和webb哥、jiqian哥沟通，无脑在图片后补参数
const urlParamObj = {
  width: 404,
  height: 404,
};

const getParam = (data) => {
  let url = '';
  for (const k in data) {
    const value = data[k] !== undefined ? data[k] : '';
    url += `&${k}=${encodeURIComponent(value)}`;
  }
  return url !== '' ? url.substring(1) : '';
};

const getUrl = (url, data) => {
  // 如果是base64图片，不需要拼接参数
  if (url.indexOf('data:image') > -1) {
    return url;
  }

  const existParam = url.indexOf('?') > -1;
  const param = getParam(data);
  url += (existParam ? '&' : '?') + param;
  return url;
};

const image = {
  render(node) {
    const { props } = node;
    const { attrs, style, action } = props;

    const { width, height } = style;
    const src = getUrl(attrs.src, urlParamObj);
    // bugfix，广交会结构化消息中引用超级大图，导致工作台crash，需要在src中加width和height参数取小图，所以这里和webb哥、jiqian哥沟通，无脑在图片后补参数

    if (action.type) {
      return `<div style="${getHtmlStyle(style)}" ${customEventFunAttr}="${action.type}" ${customEventTypeAttr}="${action.eventType}"><img style="width: ${width}; height: ${height};" src="${src}" title="${attrs.toolTip || ''}" /></div>`;
    }
    return `<div style="${getHtmlStyle(style)}"><img style="width: ${width}; height: ${height};" src="${src}" title="${attrs.toolTip || ''}" /></div>`;
  },
};

export default image;
